import React, { ReactNode } from "react";
import './ModeTile.scss';

interface IModeTileProps {
  label: string;
  icon: ReactNode;
  onClick: () => void;
}

export const ModeTile = ({
  label,
  icon,
  onClick,
}: IModeTileProps) => {
  return (
    <div
      className={`mode-tile`}
      onClick={onClick}
    >
      
        {icon}
        <span>{label}</span>
      
    </div>
  );
}